"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omit = void 0;
const record_js_1 = require("./record.js");
const reduceKey_js_1 = require("./reduceKey.js");
function omit(subject, ...props) {
    return (0, reduceKey_js_1.reduceByKey)(subject, (p, k) => {
        if (props.indexOf(k) === -1)
            p[k] = subject[k];
        return p;
    }, Object.getPrototypeOf(subject) === null ? (0, record_js_1.record)() : {});
}
exports.omit = omit;
//# sourceMappingURL=omit.js.map